export const AVOID_KEYWORDS_VALUES = [
  "construction",
  "janitorial",
  "landscaping",
  "food service",
  "catering",
  "physical security guard",
  "uniforms",
  "laundry",
];
export const KEYWORDS_VALUES = [
  "analytics",
  "intelligence",
  "software",
  "application",
  "system",
  "data",
  "ai",
  "artificial intelligence",
  "machine learning",
  "automation",
  "data science",
  "cyber",
  "cybersecurity",
  "cloud",
  "digital",
  "modernization",
  "transformation",
  "consulting",
  "engineering",
  "technical",
  "support",
  "services",
  "development",
  "design",
  "management",
  "research",
  "analysis",
  "network",
  "infrastructure",
  "information",
  "systems",
];
export const DEPARTMENTS_VALUES = [
  "Sales",
  "Marketing",
  "Engineering",
  "Product",
  "Design",
  "Operations",
  "Customer Support",
  "Human Resources",
  "Finance",
  "Legal",
];

export const NAICS_CODES_VALUES = [
  "541511",
  "541512",
  "541513",
  "541519",
  "541611",
  "541612",
  "541613",
  "541614",
  "541618",
  "541619",
];

export const USER_ROLES = {
  ADMIN: "admin",
  MEMBER: "member",
  SUPER_ADMIN: "super_admin",
};
